import {Injectable} from '@angular/core';
import {OrderM} from "../model/order.mobel";
import {PaymentM} from "../model/payment";
import {Http, Headers, RequestOptions} from "@angular/http";
import {UserM} from "../model/user.model";
import {UserDetailM} from "../model/user_detail.model";
import {Subject} from "rxjs/Subject";
import {number} from "ng2-validation/dist/number";
import {Util} from "../util/util";

@Injectable()
export class UserService {
  private order: OrderM = new OrderM();
  private user: UserM = new UserM();
  private branch_id = new Subject<number>()
  private showBranch = new Subject<boolean>()

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getProfile(type: string = 'profile') {
    this.reloadToken()
    return this.http.get(`/api/user/${type}`, this.options).map(res => res.json());
  }

  updateProfile(type: string = 'profile', user: UserM) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({headers: headers});

    ////console.log(`user:${user}`);

    this.reloadToken()
    return this.http.put(`/api/user/${type}`, user, options).map(res => res.json());
  }

  getAllStudent(searchStr: string = "", status: string = "", offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/user/studentsByAdmin?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getAllUser(userType: string = "customer", searchStr: string = "", status: string = "", statusVerified: string = "", startDate: string = "", endDate: string = "", offset = 0, limit = 30,userType2='') {
    this.reloadToken()
    return this.http.get(`/api/user/listUserByAdmin?userType=${userType}&type2=${userType2}&searchStr=${searchStr}&status=${status}&statusVerified=${statusVerified}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getUserInfo(id: number) {
    this.reloadToken()
    return this.http.get(`/api/user/info/${id}`, this.options).map(res => res.json());
  }

  getUserDetail() {
    this.reloadToken()
    return this.http.get(`/api/user/userDetail`, this.options).map(res => res.json());
  }

  getUserPermission(id: number) {
    this.reloadToken()
    return this.http.get(`/api/user/permission/:${id}`, this.options).map(res => res.json());
  }

  getShipRates(user_id: number) {
    this.reloadToken()
    return this.http.get(`/api/user/shipping_rate/${user_id}`, this.options).map(res => res.json());
  }

  getShipRateOption() {
    this.reloadToken()
    return this.http.get(`/api/user/shipping_rate_option`, this.options).map(res => res.json());
  }

  updateShipRates(user_id: number, shipRates) {
    this.reloadToken()
    return this.http.put(`/api/user/shipping_rate/${user_id}`, {shipping_rates: shipRates}, this.options).map(res => res.json());
  }

  createAdminUser(user: UserM) {
    this.reloadToken()
    return this.http.post(`/api/user/admin`, user, this.options).map(res => res.json());
  }

  updateAdminUser(user: UserM) {
    this.reloadToken()
    return this.http.put(`/api/user/admin`, user, this.options).map(res => res.json());
  }

  createUserDetail(userDetail: UserDetailM) {
    this.reloadToken()
    return this.http.post(`/api/user/userDetail`, userDetail, this.options).map(res => res.json());
  }

  createSeller(user: UserM) {
    this.reloadToken()
    return this.http.post(`/api/user/seller`, user, this.options).map(res => res.json());
  }

  updateCustomer(user: UserM) {
    this.reloadToken()
    return this.http.put(`/api/user/customer`, user, this.options).map(res => res.json());
  }

  updateUserDetail(userDetail: UserDetailM) {
    this.reloadToken()
    return this.http.put(`/api/user/userDetail`, userDetail, this.options).map(res => res.json());
  }

  deleteUserDetail(id: string) {
    this.reloadToken()
    return this.http.delete(`/api/user/userDetail/${id}`, this.options).map(res => res.json());
  }

  approveUser(user: UserM) {
    this.reloadToken()
    return this.http.put(`/api/user/approve`, user, this.options).map(res => res.json());
  }

  changeStatus(user_id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/user/status/${user_id}/${status}`, null, this.options).map(res => res.json());
  }

  getPosingPassword(user_id: number) {
    this.reloadToken()
    return this.http.get(`/api/user/getPosingPassword/${user_id}`, this.options).map(res => res.json());
  }

  getPermission(user_id: number) {
    this.reloadToken()
    return this.http.get(`/api/user/permission/${user_id}`, this.options).map(res => res.json());
  }

  getPermissionOfAdmin() {
    this.reloadToken()
    return this.http.get(`/api/user/permission_admin`, this.options).map(res => res.json());
  }

  getUserDetailById(user_id: number) {
    this.reloadToken()
    return this.http.get(`/api/user/details/${user_id}`, this.options).map(res => res.json());
  }

  getPosingHash() {
    this.reloadToken()
    return this.http.get(`/api/user/getPosingHash`, this.options).map(res => res.json());
  }

  getBranch() {
    this.reloadToken()
    return this.http.get(`/api/user/branch`, this.options).map(res => res.json());
  }

  getBranchList() {
    this.reloadToken()
    return this.http.get(`/api/user/branchList`, this.options).map(res => res.json());
  }

  setBranch(branch_id: number) {
    this.reloadToken()
    return this.http.put(`/api/user/branch/${branch_id}`, {}, this.options).map(res => res.json());
  }


  subscribeBranchChange() {
    this.reloadToken()
    return this.branch_id.asObservable()
  }

  triggerChangeBranch(branch_id: number) {
    this.branch_id.next(branch_id)
  }

  subscribeShowBranchOnNavigation() {
    this.reloadToken()
    return this.showBranch.asObservable()
  }

  setShowBranchOnNavigation(show: boolean = true) {
    this.showBranch.next(show)
  }

  changeAdmin(user_id) {
    this.reloadToken()
    return this.http.get(`/api/authen/changeAdmin/1/1/${user_id}`, this.options).map(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts